(function(){

    //Header search field control
    jQuery('.search-btn > i').click(function(e){
        e.preventDefault();

        jQuery(this).parent().addClass('active');
    });

    //mobile menu control
    jQuery('.mobile-btn').click(function(){
        jQuery('.main-header-menu').stop().slideToggle(300);
    });

    //Footer scroll top
    function footer_scroll(){
        var windowScroll = jQuery(document).scrollTop();

        if(windowScroll > 100){
            jQuery('.scroll-top').addClass('active');
        }else{
            jQuery('.scroll-top').removeClass('active');
        }
    }
    jQuery('.scroll-top').click(function(){
        jQuery('body, html').animate({'scrollTop' : 0}, 1000);
    });

    jQuery(document).scroll(function(){
        footer_scroll();
    });

    var windowSize = jQuery(window).width();
    function mobileAdjust(){
        if(windowSize < 589){
            if( ! jQuery('.mobile-dropdown').length){
                jQuery('li.menu-item-has-children').each(function(i, e){
                    jQuery(e).prepend('<div class="mobile-dropdown"><i class="fa fa-caret-down"></i></div>');
                });
            }
        }else{
            jQuery('.main-header-menu').removeAttr('style');

            if(jQuery('.mobile-dropdown').length){
                jQuery('.mobile-dropdown').each(function(i, e){
                   jQuery(e).remove();
                });
            }
        }
    }
    mobileAdjust();

    jQuery(window).resize(function(){
        windowSize = jQuery(this).width();
        mobileAdjust();
    });

    jQuery(document).delegate('.mobile-dropdown', 'click', function(e){
        jQuery(this).nextAll('.sub-menu').stop().slideToggle(300);
    });

    if (jQuery(".job-listing-hold").length) {

        var mixer = mixitup(".job-listing-hold", {
            animation: {
                duration: 250,
                nudge: false,
                reverseOut: false,
                effects: ""
            },
            multifilter: {
                enable: true
            }
        });


        new List("job-listing-hold");
    }

    jQuery('.select-two').select2({
        placeholder: 'Search'
    });

    jQuery('.select-two').on("change", function(){

        var data = jQuery(this).val();

        if(data != '' || typeof data == 'undefined'){

            window.location.href = data;

        }


    });


}(jQuery));